import {INotamAI} from '@/firebase/airport';
import moment, {Moment} from 'moment';

export const checkNotamEffective = (
  item: INotamAI,
  eta: Moment | undefined
) => {
  if (!item?.effectivity && item?.active === 'Active') return true;
  if (item?.active === 'Active' && !eta) return true;
  if (!eta) return false;
  // if effectivity periods are specified, set to Effective if eta is within any of the effectivity periods
  // e.g: [['08/03/2024 00:00', '08/03/2024 05:00'], ['09/03/2024 00:00', '09/03/2024 05:00']]
  const effectivity = item?.effectivity?.map((period) => {
    const start = moment(period[0], 'DD/MM/YYYY HH:mm');
    const end = moment(period[1], 'DD/MM/YYYY HH:mm');
    return eta.isSameOrAfter(start) && eta.isSameOrBefore(end);
  });
  return effectivity?.includes(true) ?? false;
};

export const checkNoteEffective = (item: INotamAI, eta: Moment | undefined) => {
  if (!item?.effectivity) return true;
  if (!eta) return false;
  // if effectivity periods are specified, set to Effective if eta is within any of the effectivity periods
  // e.g: [['08/03/2024 00:00', '08/03/2024 05:00'], ['09/03/2024 00:00', '09/03/2024 05:00']]
  const effectivity = item?.effectivity?.map((period) => {
    const start = moment(period[0], 'DD/MM/YYYY HH:mm');
    const end = moment(period[1], 'DD/MM/YYYY HH:mm');
    return eta.isSameOrAfter(start) && eta.isSameOrBefore(end);
  });
  return effectivity?.includes(true) ?? false;
};
